export const PENDING_COURSE_ID_STORAGE_KEY = 'saha.pendingCourseIdAfterEmailVerification';

export const getCourseId = (value: string | null | undefined): number | undefined => {
    if (typeof value !== 'string' || !/^[1-9]\d*$/.test(value)) {
        return undefined;
    }

    const courseId = Number(value);
    return Number.isSafeInteger(courseId) ? courseId : undefined;
};

export const getCoursePath = (courseId: number): string => `/course/${courseId}`;

export const getLoginPath = (courseId: number): string => `/giris?course=${courseId}`;

export const getPostLoginPath = (courseId: string | null | undefined): string => {
    const validCourseId = getCourseId(courseId);
    return validCourseId ? getCoursePath(validCourseId) : '/';
};

export const savePendingCourseId = (courseId: number | undefined): void => {
    const validCourseId = getCourseId(courseId?.toString());

    if (validCourseId) {
        localStorage.setItem(PENDING_COURSE_ID_STORAGE_KEY, String(validCourseId));
        return;
    }

    localStorage.removeItem(PENDING_COURSE_ID_STORAGE_KEY);
};

export const consumePendingCourseId = (): number | undefined => {
    const courseId = getCourseId(localStorage.getItem(PENDING_COURSE_ID_STORAGE_KEY));
    localStorage.removeItem(PENDING_COURSE_ID_STORAGE_KEY);
    return courseId;
};
